export interface FeatureFlagConfig {
	roles?: string[];               // Allowed roles (e.g., ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'])
	emails?: string[];              // Allowed user emails (lowercased recommended)
	emailRoles?: string[];          // When set, the email allowlist applies only to users in these roles
	clientIds?: string[];           // Allowed client IDs
	marketIds?: string[];           // Allowed market IDs
	campusIds?: string[];           // Allowed campus IDs
	distributorIds?: string[];      // Allowed distributor IDs
	portalViews?: string[];         // Allowed portal views (e.g., ['retail'] for Retail Admins)
	hosts?: string[];              // Allowed runtime hosts from config.json (e.g., ['local', 'staging'])
}


export const FEATURE_FLAG_CONFIGS: { [featureName: string]: FeatureFlagConfig } = {
	orders: {
		roles: ['sadmin'],  // All super admins only
		clientIds: ['1009'], // Add allowed client IDs here (e.g., ['client-id-1', 'client-id-2'])
		marketIds: [], // Add allowed market IDs here (e.g., ['market-id-1', 'market-id-2'])
		campusIds: ['12'],  // Add allowed campus IDs here (e.g., ['campus-id-1', 'campus-id-2'])
		distributorIds: []  // Add allowed distributor IDs here (e.g., ['dist-id-1', 'dist-id-2'])
	},
	flex_mock: {
		roles: ['sadmin'],
		emails: [
			'gavin.kerr@vendibean.com',
			'teal@vendibean.com',
			'tristan@vendibean.com',
			'neil@vendibean.com',
			'raviraj.shinde@vendibean.com',
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	camera_audit: {
		roles: ['sadmin'],
		emails: [
			'tristan@vendibean.com',
			'raviraj.shinde@vendibean.com',
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// Super admins and Retail Admins (campus admins on the retail portal). Ops campus admins and the
	// other admin roles stay out.
	vouchers: {
		hosts: ['local', 'staging', 'prod'],
		roles: ['sadmin'],
		portalViews: ['retail'],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// Tech leads register card readers when a market's technician asks: every super admin, plus the
	// market admins listed here.
	card_reader_registration: {
		roles: ['sadmin', 'marketadmin'],
		emails: [
			'rosdy.castro@vendibean.com',
			'arie.diaz@vendibean.com',
		],
		emailRoles: ['marketadmin'],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	card_reader_list: {
		roles: ['sadmin'],
		emails: [
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// The Card reader column on retail analytics' Live tab, until readers are linked to machines on
	// prod (DEV-822); until then every machine shows "No reader".
	retail_live_readers: {
		roles: ['sadmin'],
		emails: [
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// The Vending and cold brew card on the retail analytics overview, while it's being tried out.
	retail_mix: {
		roles: ['sadmin'],
		emails: [
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// The Insights section on the retail analytics pages, while its thresholds are tuned.
	retail_insights: {
		roles: ['sadmin'],
		emails: [
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	// A canister's level over time from the machine's Inventory page. Only Alex until machine restocks
	// are being recorded: before then the machine's level can't be rebuilt across most restocks.
	canister_history: {
		roles: ['sadmin'],
		emails: [
			'alex.davis@vendibean.com',
		],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	cold_brew: {
		roles: ['sadmin'], // Every super admin
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	},
	free_mode: {
		hosts: ['local', 'staging'],
		roles: ['sadmin', 'distiadmin', 'marketadmin', 'clientadmin', 'campusadmin'],
		clientIds: [],
		marketIds: [],
		campusIds: [],
		distributorIds: [],
	}
	// Future features can be added here:
	// 'another-feature': {
	//   roles: ['sadmin'],
	//   clientIds: [],
	//   campusIds: [],
	//   distributorIds: []
	// }
};
